module.exports = {
    FABRIC: 'Fabric',
    SUIT: 'Suit'
}